import React from 'react';
import {Affix, Col, Layout, Row} from "antd";
import PropTypes from 'prop-types';

import './menuLayout.scss';
import Nav from "../../components/nav/nav";

MenuLayout.propTypes = {
    children: PropTypes.node,
    menu: PropTypes.object,
};

function  MenuLayout(props) {
    const { children, menu } = props;


    return (
        <Layout className='menu-layout'>
            <Row className='flex-container'>
                <Affix className='sticky-menu' offsetTop={64}><Nav menu={menu}/></Affix>
                <Col className='right-content' span={20}> { children }</Col>
            </Row>
        </Layout>
    )
}

export default MenuLayout;
